// extracted by mini-css-extract-plugin
export default {"button":"styles_button__IFnXi","outline":"styles_outline__ca8HO","link":"styles_link__Uq9y9","sm":"styles_sm__CV63B","icon":"styles_icon__sOXqd"};